import {OptionFilter} from "@/lib/store/state/filters/OptionFilter";

export class DocumentTypeFilter extends OptionFilter {
    public defaultValue: string = null;
    public defaultText: string = "Document Type";
}
